<template>
  <o-modal
    ref="modal"
    :title="$t('components.reservationCustomer.actions.recurrence.title')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.save'), type: 'confirm', callback: confirm },
    ]"
    modal-class="m-2 bg-gray-50 rounded-lg shadow-lg pointer-events-auto overflow-hidden sm:max-w-md sm:w-full h-full max-h-lg dark:bg-gray-900"
    content-class="mx-auto max-w-lg flex flex-col"
  >
    <div v-if="reservationCustomer" class="text-left h-full pb-4">
      <o-scroll class="border rounded-md shadow-sm">
        <div>
          <div class="p-2">
            <recur-customer :reservation="reservationCustomer.reservation" v-model:reservations="reservations" v-model:customer="reservationCustomer.customer" />
          </div>
        </div>
      </o-scroll>
    </div>
  </o-modal>
</template>

<script setup lang="ts">
import RecurCustomer from '@/components/recurrence/elements/Customer.vue'

interface Props {
  loading?: boolean
}

interface Emits {
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const modal = ref<any>()
const reservationCustomer = ref<any>(null)
const reservations = ref<any[]>([])

const open = (rc: any) => {
  reservations.value = []

  if (rc) {
    reservationCustomer.value = rc
  }

  modal.value.open()
}

const confirm = async () => {
  try {
    const reservationCustomerIds = [reservationCustomer.value.idReservationCustomer]
    const reservationData = reservations.value
      .map(({ reservation, action }: any) => {
        return {
          idReservation: reservation.idReservation,
          date: reservation.date,
          action: action.value,
        }
      })

    const response = await $api.reservation.recurCustomers(
      reservationCustomer.value.reservation.objectID(),
      { reservationCustomerIds, reservations: reservationData }
    )

    if (response.success) {
      $notification.toast({
        title: $i18n.t('components.reservationCustomer.actions.recurrence.success'),
        variant: 'success',
      })
      emit('success')
      return true
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({
  open,
})
</script>
